
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/[...category]",
      function () {
        return require("private-next-pages/settings/[...category].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/[...category]"])
      });
    }
  